"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_1 = require("react-router");
const zustandStore_1 = require("../../../zustandStore");
const approvalsHeader_1 = __importDefault(require("./approvalsHeader"));
const ApprovalsContainer = ({ children }) => {
    const { setHeaderName } = (0, zustandStore_1.useZustand)();
    const location = (0, react_router_1.useLocation)();
    (0, react_1.useEffect)(() => {
        setHeaderName('Approvals');
    }, [location.pathname, setHeaderName]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(approvalsHeader_1.default, {}), children] }));
};
exports.default = ApprovalsContainer;
